export const OWC_PERSONALISATION_CONNECTION = 'OWC_PERSONALISATION_DATA';

export enum dispatchers {
  addPersonalisationData = 'addPersonalisationData',
  addItemsToShow = 'addSliderItems',
}

export enum stateProps {
  data = 'personalisationData',
  itemsToShow = 'itemsToShow',
}

export type OWCPersonalisationState = (OWCPersonalisationData & OWCSliderItems)[];

export type OWCPersonalisationData = {
  [key: string]: unknown;
  componentId: string;
  personalisationData: Record<string, unknown>;
};

export type OWCSliderItems = {
  [key: string]: string | Array<string>;
  componentId: string;
  itemsToShow: Array<string>;
};
